import React from 'react';
import { Box, Stack } from '@mui/material';
import Image, { StaticImageData } from 'next/image';

interface BannerInfo {
  alt: string;
  image: StaticImageData;
}

export const BannerSlides: React.FC<BannerInfo> = ({ alt, image }) => {
  return (
    <Stack>
      <Box sx={{ '& img': { width: '100%' } }}>
        <Image src={image} alt={alt} />
      </Box>
    </Stack>
  );
};
